import MuiSkeleton, { SkeletonProps } from '@mui/material/Skeleton';

export interface ISkeletonProps extends SkeletonProps {}

const Skeleton = (props: ISkeletonProps): JSX.Element => {
  return <MuiSkeleton {...props} />;
};

export default Skeleton;
